import classnames from 'classnames'
import PropTypes from 'prop-types'

import CircleIconWrapper from './CircleIconWrapper'

import CircleCheckIcon from './CircleCheckIcon'

import './boxWithTextAndCircleCheckWithNumber.scss'

const BoxWithTextAndCircleCheckWithNumber = ({
  children,
  className,
  textClass
}) => (
  <div className='box-with-text-and-circle-check-with-number flex-child flex-container'>
    <div className={classnames(textClass, 'flex-child flex-container')}>
      <CircleIconWrapper>
        <CircleCheckIcon />
      </CircleIconWrapper>
      <div className={className}>
        {children}
      </div>
    </div>
  </div>
)

BoxWithTextAndCircleCheckWithNumber.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  textClass: PropTypes.string
}

export default BoxWithTextAndCircleCheckWithNumber
